import { useState } from 'react'
import { MdKeyboardArrowRight, MdOutlineExpandMore } from 'react-icons/md';
import { IoMdCheckmark } from 'react-icons/io';
import { useShop } from '../../Providers/ShopProvider';
import { useAuth } from '../../Providers/AuthProvider';
import useGetAvailabilityFiltersNames from './Hooks/useGetAvailabilityFiltersNames';

import './ProductFeature.css'

const ProductFilterOnlyAvailable = () => {
  const { authState } = useAuth()
  const { productsFilter, setProductsFilter } = useShop()
  const { availabilityFiltersNames } = useGetAvailabilityFiltersNames()
  const [showContent, setShowContent] = useState(true)

  const handleSelectUnSelectFilter = (index) => {
    setProductsFilter(prev => {
      const currentFilters = prev.AvailabilityFilters;
      return {
        ...prev,
        AvailabilityFilters: {
          OnlyLocal: index === 0 ? !currentFilters.OnlyLocal : false,
          OnlyRegional: index === 1 ? !currentFilters.OnlyRegional : false,
          OnlyMacroRegional: index === 2 ? !currentFilters.OnlyMacroRegional : false
        }
      }
    })
  }

  const isFilterChecked = (index) => {
    switch (index) {
      case 0:
        return productsFilter.AvailabilityFilters.OnlyLocal
      case 1:
        return productsFilter.AvailabilityFilters.OnlyRegional
      case 2:
        return productsFilter.AvailabilityFilters.OnlyMacroRegional
    }
  }

  const handleAllArticlesFilterChange = () => {
    setProductsFilter(prev => ({
      ...prev,
      AllArticles: !prev.AllArticles
    }))
  }

  return (
    <div className='feature'>
      <div className='feature-name row' onClick={() => setShowContent(!showContent)}>
        <div className='col'>{'Dostępność'}</div>
        <div className='col-auto expandMore-icon' >{showContent ? <MdOutlineExpandMore size={25} /> : <MdKeyboardArrowRight size={25} />}</div>
      </div>
      {authState.whId && authState.siteId && <div className={showContent ? 'feature-values show' : 'feature-values'}>
        {availabilityFiltersNames.length > 0 &&
          availabilityFiltersNames.map((item, key) => {
            let isChecked = isFilterChecked(key)
            return (
              <div className='row align-items-center' key={key}>
                <div className={`col-1 custom-radio element-pointer ${isChecked ? 'checked' : 'unchecked'}`} onClick={() => handleSelectUnSelectFilter(key)}>
                  {isChecked &&
                    <span className="checkmark">
                      <IoMdCheckmark />
                    </span>}
                </div>
                <div className='col-auto user-select-none'>
                  {item}
                </div>
              </div>
            )
          })
        }
      </div>}
      <div className={showContent ? 'feature-values show' : 'feature-values'}>
        <div className="row align-items-center">
          <div className={`col-1 checkbox ${productsFilter.AllArticles ? 'checked' : 'unchecked'}`} onClick={handleAllArticlesFilterChange}>
            {productsFilter.AllArticles &&
              <span className="checkmark">
                <IoMdCheckmark />
              </span>}
          </div>
          <div className="col user-select-none">
            <span>Baza produktów na zamówienie</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductFilterOnlyAvailable